import { usePublicationLibbyCall } from "./PublicationBusinessGenerated";
import { Publication } from "../../models";

export const usePublication = (publication: string) =>
  usePublicationLibbyCall<Publication[]>({ methodName: "getByPublication", params: [publication] });
